import Pqp from "../../3x1010/Pqp";
import Cell from "./Cell";
import CellDesign from "./design/CellDesign";
import Maze from "./Maze";
import MazeConst from "./MazeConst";

export default class Room {
	constructor(id, type, w, h, secret = false, roomIndex = -1) {
		this.id = id;
		this.type = type;
		this.w = w;
		this.h = h;
		this.cells = undefined;
		this.exits = new Array();
		this.secret = secret;
		this.paving = -1;
		this.roomIndex = roomIndex;
	}

	init(cellsCollection) {
		// Costruisce la matrice
		this.rowStart = cellsCollection[0].row;
		this.colStart = cellsCollection[0].col;
		this.build(cellsCollection);
	}

	build(cellsCollection) {
		this.cells = new Array();
		for (let row = 0; row < this.h; row++) {
			this.cells.push(new Array())
			for (let col = 0; col < this.w; col++) {
				this.cells[row][col] = cellsCollection[row * this.w + col];
				this.cells[row][col].rowRoom = row;
				this.cells[row][col].colRoom = col;
			}
		}
	}

	getBorderCells() {
		let ret = new Array();
		for (let row = 0; row < this.h; row++) {
			for (let col = 0; col < this.w; col++) {
				let lGet = false;
				let cell = this.cells[row][col];
				if (row === 0) {
					lGet = true;
				}
				if (row === this.h - 1) {
					lGet = true;
				}
				if (col === 0) {
					lGet = true;
				}
				if (col === this.w - 1) {
					lGet = true;
				}
				if (lGet) {
					ret.push(cell);
				}
			}
		}
		return ret;
	}

	destroyBecauseUnreachable() {
		for (let row = 0; row < this.h; row++) {
			for (let col = 0; col < this.w; col++) {
				let cell = this.cells[row][col];
				cell.room = CellDesign.NOT_BELONG_TO_A_ROOM;
				//cell.type = Cell.TYPE_WALL;
			}
		}
	}

	isCornerCell(cell) {
		if ((cell.rowRoom === 0) && (cell.colRoom === 0)) {
			return true;
		}
		if ((cell.rowRoom === 0) && (cell.colRoom === this.w - 1)) {
			return true;
		}
		if ((cell.rowRoom === this.h - 1) && (cell.colRoom === 0)) {
			return true;
		}
		if ((cell.rowRoom === this.h - 1) && (cell.colRoom === this.w - 1)) {
			return true;
		}
		return false;
	}

	addExit(cell) {
		this.exits.push(cell);

	}

	isSecret() {
		return this.secret;
	}

	isHallway() {
		if (this.type === MazeConst.ROOM_TYPE_HALLWAY) {
			return true;
		}
		return false;
	}

	getCenterCell() {
		return this.cells[Math.floor(this.h / 2)][Math.floor(this.w / 2)];

	}

	getFreeCellNearCenterCell() {
		let cell = this.getCenterCell();
		let lFound = false;
		if (!cell.canWalk() || cell.booked) {
			let dir = [Maze.DIR_NW, Maze.DIR_N, Maze.DIR_NE, Maze.DIR_W, Maze.DIR_E, Maze.DIR_SW, Maze.DIR_S, Maze.DIR_SE];
			let model = cell.model;
			for (let x = 0; x < dir.length; x++) {
				let tmp = model.getNearbyCell(cell, dir[x]);
				if (tmp.canWalk() && !tmp.booked) {
					cell = tmp;
					lFound = true;
					break;
				}
			}
		} else {
			lFound = true;
		}
		if (!lFound) {
			for (let row = 0; row < this.h; row++) {
				for (let col = 0; col < this.w; col++) {
					let tmp = this.cells[row][col];
					if (tmp.canWalk() && !tmp.booked) {
						cell = tmp;
						lFound = true;
						break;
					}
				}
				if (lFound) {
					break;
				}
			}
		}
		return cell;
	}

	getFreeCellUpperRow() {
		let free = new Array();
		for (let x = 0; x < this.w; x++) {
			let cell = this.cells[0][x];
			if (cell.canWalk()) {
				if (!this.isCornerCell(cell)) {
					let n = cell.model.getNearbyCell(cell, Maze.DIR_N);
					if (n.isWall()) {
						let s = cell.model.getNearbyCell(cell, Maze.DIR_S);
						if (s.canWalk()) {
							free.push(cell);
						}
					}
				} else {
					let side
					if (x == 0) {
						side = cell.model.getNearbyCell(cell, Maze.DIR_W);
					} else {
						side = cell.model.getNearbyCell(cell, Maze.DIR_E);
					}
					let n = cell.model.getNearbyCell(cell, Maze.DIR_N);
					if (n.isWall()) {
						if (side.isWall()) {
							free.push(cell);
						}
					}
				}
			}
		}
		return free[Pqp.rnd(free.length - 1)];
	}

	getSuitablePlaceFor(type) { // tpye to do
		let cell = this.getFreeCellNearCenterCell();
		let n = cell.model.getNearbyCell(cell, Maze.DIR_N);
		if ((n.canWalk()) && (!n.booked) && (!n.end)) {
			//console.log(n.canWalk(), n.booked);
			return cell;
		}
		//console.log("AZZZZ")
		let lFound = false;
		for (let row = 0; row < this.h; row++) {
			for (let col = 0; col < this.w; col++) {
				let tmp = this.cells[row][col];
				if (tmp.canWalk() && !tmp.booked) {
					let n = tmp.model.getNearbyCell(tmp, Maze.DIR_N);
					console.log(n);
					if (((n.isWall()) || (!n.booked)) && (!n.isRoomExit()) && (!n.end)) {
						console.log(n.isChest())
						let e = tmp.model.getNearbyCell(tmp, Maze.DIR_E);
						console.log(e.isChest())
						if ((!e.isRoomExit()) && (!e.end)) {
							let w = tmp.model.getNearbyCell(tmp, Maze.DIR_W);
							if ((!w.isRoomExit()) && (!w.end)) {
								let s = tmp.model.getNearbyCell(tmp, Maze.DIR_S);
								if ((!s.isRoomExit()) && (!s.end)) {
									cell = tmp;
									lFound = true;
									break;
								}
							}
						}
					}
				}
			}
			if (lFound) {
				break;
			}
		}
		return cell;

	}


}